import script from "./progress-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./progress-bar.vue?vue&type=script&setup=true&lang=js"

import "./progress-bar.vue?vue&type=style&index=0&id=230453f1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230453f1"]])

export default __exports__